"use client";
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { getProfile } from '@/profiles/getProfile';

export const CookieCheck = ({ location, isLandingPage = false, locale, displayNames } : { location: string | string[], isLandingPage?: boolean, locale?: string, displayNames?: string }) => {
  const profile = getProfile(process.env.NEXT_PUBLIC_PROFILE);
  useEffect(() => {
    if (typeof window !== "undefined") {
      if(isLandingPage === true || window?.location?.pathname?.includes('tags') || window?.location?.pathname?.includes('collection')){
        // prevent articles, case-studies, video post pages from updating the breadcrumb cookie. 
        // Check that the page isn't a landing page at base URL (i.e. the locale)
        const cookieValue = JSON?.stringify({ "text": displayNames ? displayNames : `${profile?.BASE_URL}${window?.location?.pathname}`, "link": `${profile?.BASE_URL}${window?.location?.pathname}` });
        if((window?.location?.pathname === `/${locale}`)) {
          // reset the cookie if user hits a landing page - we don't want to keep the previous tag/collection page if the user has just hit the landing page
          Cookies.remove("breadcrumbPreviousPage");
        } else {
          const path = profile?.BASE_URL;
          const basePath = path?.charAt(path?.length -1) != '/' ? `${profile?.BASE_URL}/${locale}`: `${profile?.BASE_URL}${locale}`;
          Cookies.set("breadcrumbPreviousPage",  cookieValue, { expires: 1, path: basePath });
        }
      }
    }
    // location in dependency array to ensure the check happens when the page location changes
  }, [location, isLandingPage, locale, displayNames, profile?.BASE_URL]);
  return null;
}

